import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-input-alternatives',
  templateUrl: './input-alternatives.component.html',
  styleUrls: ['./input-alternatives.component.scss'],
})
export class InputAlternativesComponent implements OnInit {
  alternatives: string[] = [];

  constructor() {}

  @Input() source: HTMLInputElement;

  ngOnInit() {
    if (this.source) {
      this.getClosestPossibleValues(+this.source.value);
    }
  }

  get errorMessage() {
    if (this.alternatives.length === 1) {
      return 'INPUT.ERROR.ALTERNATIVE';
    } else {
      return 'INPUT.ERROR.ALTERNATIVES';
    }
  }

  setAlternativeValue(suggestion: string) {
    this.source.value = suggestion;
    this.source.dispatchEvent(new Event('input'));
  }

  getClosestPossibleValues(value: number) {
    const lower = Math.floor(value / +this.source.step) * +this.source.step;
    if (lower >= +this.source.min && lower <= +this.source.max) {
      this.alternatives.push(lower.toString());
    } else if (lower < +this.source.min) {
      this.alternatives.push(this.source.min);
    }

    const higher = Math.floor(value / +this.source.step) * +this.source.step + +this.source.step;
    if (higher <= +this.source.max && higher >= +this.source.min) {
      this.alternatives.push(higher.toString());
    } else if (higher > +this.source.max) {
      this.alternatives.push(this.source.max);
    }
  }
}
